import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'woods-product-container',
  templateUrl: './product-container.component.html',
  styleUrls: ['./product-container.component.scss']
})
export class ProductContainerComponent implements OnInit {

  @Input() producto:any;

  constructor() { }

  ngOnInit(): void {
  }

}
